module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/graff.0b18d12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/graff.jpg
// module id = GQlf
// module chunks = 0